import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
import { removeEmptyUrlParams } from "../functions/removeEmptyUrlParams";
import { TableSliderProps } from "../types";

/* Slider component to determine what type of information table displays */
export function TableSlider({ setRequestTableData, brand, urlParams }: TableSliderProps) {
  const history = useHistory();
  /* Reset filtering options when switching table states */
  useEffect(() => {
    if (brand) {
      urlParams.delete("format");
      urlParams.delete("media");
      removeEmptyUrlParams(urlParams);
      history.push({ search: `?${new URLSearchParams(urlParams)}` });
    }
  }, [brand]);

  return (
    <div data-testid="slider">
      <ComponentLibrary.PCSlider width={"220px"} height={"39px"} textSize={"text-size-3"} optionsList={["Ads", "Brands"]} icon={["square", "folder"]} activeColor={"pink"} slidingColor={"bg-white"} backgroundColor={"bg-light-gray"} borderColor={"b--light-gray"} borderRadius={"br3"} setSelectedValue={setRequestTableData} defaultOptionPosition={brand ? 1 : 0} />
    </div>
  );
}
